import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconColumns = createIcon({
  displayName: 'IconColumns',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M2 4H4V20H2V4ZM20 4H22V20H20V4ZM10 4H8V20H10V4ZM14 4H16V20H14V4Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
